import { ADDRESS_EDITING_STATUS } from '..';

export const ADDRESS_EDITING_STATUS_MESSAGE = {
  [ADDRESS_EDITING_STATUS.CREATE]: 'Novo endereço',
  [ADDRESS_EDITING_STATUS.UPDATE]: 'Atualizar endereço',
};

export const ADDRESS_EDITING_STATUS_MESSAGE_BUTTON = {
  [ADDRESS_EDITING_STATUS.CREATE]: 'Criar',
  [ADDRESS_EDITING_STATUS.UPDATE]: 'Atualizar',
};
